(function (ws) {
    'use strict';
    ws.views.carrierTrackingPdfModal = ws.views.modal.extend({
        /** TODO: Refactor this to be in common components and to accept any PDF. **/
        initialize: function () {
            ws.views.modal.prototype.initialize.call(this);
            this.$carrierTrackingPdfObject = this.$('#carrier-tracking-pdf');
            this.$forceDownloadError = $('.force-download-error');
            this.$urlError = $('.urlnot-available-error');
            this.$forcedLink = $('.forced-link');
            this.hidePdfElementIfNeeded();
        },

        /**
         * If the user is using IE we have to show a message about pdf view support
         */
        hidePdfElementIfNeeded () {
            if (this.isIEBrowser()) {
                this.$forceDownloadError.show();
                this.$carrierTrackingPdfObject.hide();
            }
        },

        /**
         *  Check if the browser is IE.
         */
        isIEBrowser () {
            return navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0;
        },

        /**
         * Overriding onOpen and setting url for pdf object
         *@param {Object} ev
         */
        onOpen (ev) {
            var pdfTemplate = this.$('#carrier-tracking-pdf');
            pdfTemplate.html('');
            const carrierTrackPdfUrl = $(ev.currentTarget).data('carrier-tracking-url');
            const carrierTrackNum = $(ev.currentTarget).data('carrierTrackingNum');
            const salesOrderNumber = $(ev.currentTarget).data('salesordernumber');
            const carrierUrl = $(ev.currentTarget).data('carrier-url');
            const carrierName = $(ev.currentTarget).data('carriertype');
            if ($('#carriersForApiCall').val().includes($(ev.currentTarget).data('carriertype').toUpperCase())) {
                $.get(`${sitePath}/pod/tracking/details?id=${carrierTrackNum}&carrierName=${carrierName}&url=${carrierTrackPdfUrl}&sapOrderId=${salesOrderNumber}`, (res) => {
                    if (res) {
                        this.changeTemplate(res);
                    }
                });
            } else {
                this.changeTemplate(carrierTrackPdfUrl);
            }

            ws.views.modal.prototype.onOpen.call(this, ev);

            if (carrierTrackPdfUrl === '' && !$(ev.currentTarget).data('carriertype')) {
                this.$urlError.show();
                this.$carrierTrackingPdfObject.hide();
            }

            if (this.isIEBrowser()) {
                if (carrierUrl != undefined) {
                    this.$forcedLink.attr('href', carrierUrl);
                } else {
                    this.$forcedLink.attr('href', carrierTrackPdfUrl);
                }

            }

            $('.carrier-tracking-modal-container').attr('style', '');
            setTimeout(function () {
                $('.carrier-tracking-modal-container').css('background', 'none');
            }, 15000);
        },

        /*
         * Template for Object tag to load the different pdf
         */
        changeTemplate: function(url) {
            var pdfTemplate = this.$('#carrier-tracking-pdf');
            pdfTemplate.html('');
            pdfTemplate.html('<object type="application/pdf" width="100%" height="100%" data="' + url + '"></object>');
        }
    });
})(westcon);
